import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-why-choose-us',
  imports: [
    NgOptimizedImage,
    TranslatePipe
  ],
  templateUrl: './why-choose-us.html',
})
export class WhyChooseUs {

}
